<template>
  <div>
    <vue-final-modal
      v-model="showModal"
      classes="modal-container"
      content-class="modal-dialog modal-content"
      :max-width="600"
      :max-height="500"
      :z-index="9999"
    >
      <button class="modal__close" @click="showModal = false">
        <i class="fas fa-times"></i>
      </button>
      <span class="modal__title">{{ title }}</span>
      <div class="modal__content">
        <div class="tabs">
          <div
            class="tab"
            v-for="sup of suppliers"
            @click="tabs.active = sup.id"
            :class="{ active: tabs.active == sup.id }"
            :key="'supid_tab_letter' + sup.id"
          >
            {{ sup.name }}
          </div>
        </div>
        <wysiwyg
          v-if="suppliers.find((x) => x.id == tabs.active)"
          v-model="suppliers.find((x) => x.id == tabs.active).letter"
        />
      </div>
      <div class="modal__footer"></div>
    </vue-final-modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      showModal: false,
      title: "Письмо",
      suppliers: [],
      tabs: {
        active: 0,
      },
    };
  },
  methods: {
    openModal({ cartList, supplier_list, warehouse }) {
      this.suppliers = [];
      console.log("open letter modal", cartList, supplier_list);
      for (let sup of supplier_list) {
        let positions = "<ul>";
        for (let pos of cartList.filter((x) => x.supplier_id == sup.id)) {
          positions += `<li>${pos.name}, ${pos.netto} — ${pos.amount} шт.</li>`;
        }
        positions += "</ul>";

        let client = {
          name: warehouse.name || "Установите название склада в настройках",
          address: warehouse.address || "Установите адрес склада в настройках",
          contacts: warehouse.contacts || [],
        };

        let default_template = {
          header: `<p>Добрый день!<br>Необходима поставка партии табака в <b>[CLIENTNAME]</b> по адресу <b>[CLIENTADDRESS]</b>.</p>`,
          list: `<p>Позиции:<br>[POSITIONS]</p>`,
          footer: `<p>Контакты:<br>[CLIENTCONTACTS]</p>`,
        };

        let letter_template = warehouse.letter_template;

        if (!letter_template) {
          letter_template = default_template;
        } else {
          letter_template = { ...default_template, ...letter_template };
        }

        console.log(warehouse, letter_template);

        let letter_proto =
          letter_template.header +
          letter_template.list +
          letter_template.footer;

        letter_proto = letter_proto.replace(/\[POSITIONS\]/g, positions);
        letter_proto = letter_proto.replace(/\[CLIENTNAME\]/g, client.name);
        letter_proto = letter_proto.replace(
          /\[CLIENTADDRESS\]/g,
          client.address
        );
        letter_proto = letter_proto.replace(
          /\[CLIENTCONTACTS\]/g,
          client.contacts
            .map((x) => `${x.value}${x.name ? " (" + x.name + ")" : ""}`)
            .join("<br>")
        );

        this.suppliers.push({
          id: sup.id,
          name: sup.name,
          letter: `${letter_proto}`,
        });
      }
      if (supplier_list.length == 1) {
        this.title = "Письмо поставщику";
      } else {
        this.title = "Письма поставщикам";
      }
      this.tabs.active = supplier_list[0].id;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: unset;
  outline: unset;
  border: unset;
  opacity: 0.8;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}

.modal__footer {
  text-align: right;
  margin-top: 50px;
}

.remove_item {
  border: unset;
  background: unset;
  outline: unset;
  cursor: pointer;
  color: black;
  opacity: 0.6;
  font-size: 10px;
  position: relative;
  &:hover {
    opacity: 1;
    color: red;
  }
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>

<style lang="scss" scoped>
.tabs {
  border-bottom: 2px solid #eee;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .tab {
    display: inline-block;
    padding: 5px 10px;
    border-bottom: 2px solid #eee;
    position: relative;
    bottom: -2px;
    cursor: pointer;

    &:hover {
      border-color: #a54ce7;
    }

    &.active {
      border-color: #8a00ef;
    }
  }
}
</style>